import styled from 'styled-components';

export const ProfilePic = styled.img`
  border-radius: 50%;
  height: 30px;
  width: 30px;
  align-self: center;
`;

export const ProfileDefaultPic = styled.div`
  background-color: #e40d39;
  color: #ffffff;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
  align-self: center;
`;

export const UnderageProfile = styled.div`
  height: 45px;
  align-items: center;
  > div:last-child {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    > p {
      margin: 0;
      height: 15px;
      text-align: start;
      margin-bottom: 4px;
      &:last-child {
        font-size: 12px;
        line-height: 24px;
        letter-spacing: normal;
        font-weight: 400;
        color: #999999;
      }
    }
  }
`;

export const Description = styled.p`
  margin: 0;
  height: 15px;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: normal;
  font-weight: 400;
  color: #666666;
`;

export const ResponsibleUnderagePending = styled.div`
  display: flex;
  align-items: center;
  ${Description} {
    margin-left: 8px;
    height: auto;
  }
`;
